// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__ASj4C"};